var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout",staticStyle:{"height":"98%","overflow-y":"auto"}},[_c('Tree',{attrs:{"data":_vm.newData},on:{"on-toggle-expand":_vm.loadData,"on-select-change":_vm.choseTree}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }